import $ from 'jquery';

export default function setupDomMoves () {
	$('#sidenav').clone().appendTo( $('#subnav-clone') );
    // $('#home-desciption').clone().appendTo( $('#desciption-clone') );
}

